<template>
  <div>
    <el-row>
      <span id="globalProjectName">
        {{this.project.data.name}}
      </span>
    </el-row>
    <el-row>
      <i class="el-icon-check icon-project project-active" v-if="getProjectState()"></i>
      <i class="el-icon-close icon-project project-inactive" v-else></i>
      <span class="specDescription">
        Average scheduled: {{ project.data.scheduled_avg }}
      </span>
    </el-row>
    <el-tabs v-model="view.commonTab">
      <el-tab-pane label="Scheduler" name="newScheduler" class="botTableContainer">
        <Scheduler :advanced="advanced.data" :bots="bots.data" :project="project.data" />
      </el-tab-pane>
      
      <el-tab-pane label="Advanced settings" name="third">
        
          <AdvancedUnited
          :advanced="advanced"
          :accounts="accounts"
          :proxies="proxies"
          :proxies_tags="proxies_tags"
          :languages="languages"
          :pools="pools"
          >
          </AdvancedUnited>
        
      </el-tab-pane>
    </el-tabs>
    
    <el-dialog
      title="Schedule bot"
      :visible.sync="dialogNow.visible"
      width="600px"
      :before-close="handleCloseNow">
      <div class="inputContainerNow" v-loading="loading">
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Delay
          </el-col>
          <el-col :span="12">
            <el-input-number :step="1" v-model="dialogNow.delay"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Tasks
          </el-col>
          <el-col :span="12">
            <el-input-number :step="5" v-model="dialogNow.tasks"></el-input-number>
          </el-col>
          </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
              Repeats
          </el-col>
          <el-col :span="12">
            <el-input-number :step="50" v-model="dialogNow.repeats"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
              Playbook ID
          </el-col>
          <el-col :span="12">
            <el-input
              id="playbookIdInput"
              placeholder="id of playbook to run"
              v-model="dialogNow.playbook_id"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
              <el-divider><i class="el-icon-star-on"></i></el-divider>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
              Video record
          </el-col>
          <el-col :span="12">
            <el-input-number
              placeholder="id of playbook to run"
              v-model="dialogNow.video_ratio">
            </el-input-number>
          </el-col>
        </el-row>
        <el-row>
          <div class='tip'>Home much do you want to record? Tell me in %</div>
        </el-row>
        
        
      
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseNow()">Cancel</el-button>
        <el-button icon="el-icon-danger" type="primary" @click="runBotNow(dialogNow.bot_id)">RUN</el-button>
      </span>
    </el-dialog>
  </div>
  
</template>

<style>
  .el-input-number--mini {
    width: 100px !important;
  }
  .containsBotLink a {
    color: #333;
    font-weight: 500 !important;
    text-decoration: none !important;
    font-size:14px;
  }
  .containsBotLink a:hover {
    
  }
  .elementId{
    font-size: 12px;
    color:grey;
    padding-top:2px;
  }
  .boldspan {
    color: #555;
    font-weight:700;
  }
  #addBot {
    margin: 0 auto;
  }
  .projectHeader {
    color: grey;
    font-size:35px;
  }
  .botTableContainer{

  }
  .tableRowClassName{
    background-color:none !important;
  }

  #scheduling {
    padding-left:25px;
  }

  #projectContainer{
    margin-top:25px;
  }

  #newBot {
    margin-bottom: 15px;
  }

  .centered {
    text-align: center;
  }

  .newBotError {
    margin-bottom:10px;
    padding-bottom:12px;
  }
  .nameCol{
    padding-top:10px;
    font-weight: 300;
  }
  .inputContainerNow{
    
    margin: 0 auto;
  }
  .nowRow{
    margin-bottom:5px;
  }
  .el-switch{
    margin-left: 15px;
  }

  .projectState {
    margin-top:5px;
    color:#555
  }

  #playbookIdInput {
    width:50px !important;
  }
  #globalProjectName {
    font-size:30px;
    color: #333;
  }
  .icon-project {
    font-weight:bold;
    font-size:1.1em;
  }
  .project-active {
    color:green;
  }
  .project-inactive {
    color:red;
  }
</style>
<script>
import { mapState, mapGetters } from 'vuex';
import DaySection from '../../components/project/DaySection';
import Scheduler from './Scheduler/Scheduler.vue';
import AdvancedSettings from '../../components/project/AdvancedSettings';
import AdvancedUnited from '../../components/AdvancedUnited';

import moment from 'moment';
import draggable from 'vuedraggable';
import Vue from 'vue';

Vue.component('draggable', draggable);
export default {
  name: 'ProjectPage',
  components: {
    draggable,
    DaySection,
    AdvancedSettings,
    AdvancedUnited,
    Scheduler
  },
  watch: {
    // whenever question changes, this function will run
    projectState: function (newVal, oldVal) {
      
    }
  },
  beforeDestroy(){
    this.$store.state.project.projects = [];
    this.$store.state.project.bots = [];
    this.$store.state.project.advanced = {};
    this.$store.state.project.playbooks = [];
  },
  methods: {
    sortBotsList() {

    },
    searchBotsByName(name) {
      var bots = [];
      bots = this.bots.data.filter(
          function(bot){
            if (bot.name.toLowerCase().indexOf(name.toLowerCase()) != -1) {
              return true;
            }
          }, this
      );
      return bots;
    },
    getBotsForOutput(){
      if (this.filterBots.length) {
         var bots = this.bots.data.filter(
          function(bot){
            if (!isNaN(this.filterBots)) {
              //this is number so lets filter by number
              if (bot.id == this.filterBots) {
                return true;
              }
            }
            if (bot.name.toLowerCase().indexOf(this.filterBots.toLowerCase()) != -1) {
              return true;
            }
          }, this
        );

        return bots;
      }
 
      return this.bots.data;
    },
    onFilterChange() {
    },
    onPlaybookFilter() {

    },
    getRate() {
      return this.failRateByProject;
    },
    handleClone(evt) {
      
    },
    runBotNow(id) {
      this.$store.dispatch('project/scheduleBotNow', {
        project_id:this.$route.params.id,
        bot_id: id,
        delay: this.dialogNow.delay,
        repeats: this.dialogNow.repeats,
        tasks: this.dialogNow.tasks,
        playbook_id: this.dialogNow.playbook_id,
        video_ratio: this.dialogNow.video_ratio
      });
    },
    onGroupsChange(e) {
      
    },
    getTitlo(){
      return 'hiio';
    },
    fetchData() {
      var to = moment().format("YYYY-MM-DD");
      var from = moment().subtract(1, 'days').format("YYYY-MM-DD");
      this.$store.dispatch('project/loadCompleteProject', {params: {id:this.$route.params.id}})
      //this.$store.dispatch('project/loadStats', {params: {id:this.$route.params.id, from: from, to: to}});
      //this.$store.dispatch('project/loadErrorTypes', {params: {id:this.$route.params.id, from: from, to: to}});
    },
    createNewBot() {
      if (this.newBotName.length) {
        this.newBotError = '';
        //save dis
        this.$store.dispatch('project/createBot', {params: {project_id:this.$route.params.id, name: this.newBotName}});
        return;
      }

      this.newBotError = 'Please, specfify a name';
    },
    handleNow(index, row) {
      this.dialogNow.visible = true;
      this.dialogNow.bot_id = row.id;
      this.dialogNow.project_id = this.$route.params.id;
    },
    handleCloseNow() {
      this.dialogNow.visible = false;
    },
    handleDeleteBot(id, element) {
      var that = this;
      this.$confirm('This will permanently delete this bot and it\'s scenario.', 'Uvaga', 
      {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
      }).then(() => {
          that.$store.dispatch('project/deleteBot', { 
            params: {
              project_id: that.$route.params.id, 
              bot_id: id,
            } 
          });
          /*this.$message({
              type: 'success',
              message: 'Delete completed'
          });*/
          }).catch(() => {
          this.$message({
              type: 'info',
              message: 'Delete canceled'
          });          
        });
    },
    handleClose(){},
    handleClick(tab, event) {
      
    },
    handleBotTabClick(tab,event) {

    },
    handleEdit(data1, data2) {

    },
    handleDelete(data1, data2) {

    },
    changeMin(e, row) {
      
    },
    changeMax(e, row) {
      
    },
  
    deletePlaybook(row, column) {

    },
    getWholeDayPlaybooks() {
      return this.getPlaybooksBySection('any');
    },
    getNightPlaybooks() {
      return this.getPlaybooksBySection('night');
    },
    getEveningPlaybooks() {
      return this.getPlaybooksBySection('evening');
    },
    getDayPlaybooks() {
      return this.getPlaybooksBySection('day');
    },
    getMorningPlaybooks() {
      return this.getPlaybooksBySection('morning');
    },
    getPlaybooksBySection(sectionName) {
      //todo replay
      var toFilter = [];//this.playbooks.data;
      var what = toFilter.filter(playbook => playbook.time_of_days == sectionName);
      return what;
    },
    dayTimeFormatter(row, column) {
      switch (row.time_of_days) {
        case 'any' : return 'Whole day';
        case 'now' : return 'Immediate';
        case 'night' : return 'Night';
        case 'day' : return 'Day';
        case 'morning' : return 'morning';
        default: return row.time_of_days;
      }
    },
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    putIntoSection(stuff) {      
      var object = {
        advanced_settings_id:1411,
        bot_id:stuff.id,
        id:'new',
        project_id: this.$route.params.id,
        goal:0,
        time_of_days:"any"
      }

      return object;
      
    },
    log: function(evt) {
      window.console.log(evt);
    },
    getBotsFromState() {
      return this.$store.state.project.bots;
    },
    failRate () {
      if (this.$store.state.project.stats.byDate.length) {
        var failRate =  (this.$store.state.project.stats.byDate[0].errors / this.$store.state.project.stats.byDate[0].total)*100;
        this.failRateByProject = failRate.toFixed(2);
      }
    },
    getStats() {
      
      
      var success = {
        name: 'Success', data: {}
      }

      var error = {
        name: 'Error', data: {}
      }
      
      this.$store.state.project.stats.aggrDate.data.forEach(function(elem){
        var key = (new Date(elem.id)).toISOString();
        success.data[key] = elem.success;
      });

      this.$store.state.project.stats.aggrDate.data.forEach(function(elem){
        var key = (new Date(elem.id)).toISOString();
        error.data[key] = elem.errors;
      });


      //[(new Date(elem.id)).toISOString(),elem.success],
      //[(new Date(elem.id)).toISOString(),elem.errors],
      var modifArr = [
        success, error
        //{name: 'Success', data: {'2017-01-01': 3, '2017-01-02': 4}},
        //{name: 'Errors', data: {'2017-01-01': 5, '2017-01-02': 3}}
      ];

      return modifArr;//[['Sun', 32], ['Mon', 46], ['Tue', 28]];
    },
    getProjectState() {
      var state = this.project.data.status;
      switch(state) {
        case 'active':
          return true;
          break;
        case 'finished':
        case 'inactive':
          return false;
      }
    },
    toggleState(newVal) {
      if (newVal === true) {
        this.$store.dispatch('project/activateProjectAction', {
            params: {
              project_id: this.$route.params.id,
              name: this.project.data.name
            }
          });
      }
      
      if (newVal === false) {
        this.$store.dispatch('project/deactivateProjectAction', {
            params: {
              project_id: this.$route.params.id,
              name: this.project.data.name
            }
          });
      }
    }
  },
  data () {
    return {
      filteringData: {},
      failRateByProject: 0,
      bots1: this.getBotsFromState(),
      byErrors :[
        {name: 'Workout', data: {'2017-01-01 00:00:00 -0800': 3, '2017-01-02 00:00:00 -0800': 4}},
        {name: 'Call parents', data: {'2017-01-01 00:00:00 -0800': 5, '2017-01-02 00:00:00 -0800': 3}}
      ],
      temp: [{name:'webdriver', data:{"2019-05-26":0,"2019-05-27":15,"2019-05-28":4,"2019-05-29":0}},
        {name:'proxy', data:{"2019-05-26":4,"2019-05-27":15,"2019-05-28":11,"2019-05-29":4}}  
      ],
      prStat: [
        ['Success',]
      ],
      types: {
        day: 'Day',
        whole: 'Whole day',
        night: 'Night',
        morning: 'Morning'
      },
      view: {
        activeTab:'first',
        botActiveTab: 'bots',
        commonTab: 'newScheduler'
      },
      editRepeat: {
        min: 0,
        max: 0
      },
      editedData:{
        playbooks:[],
        botsList:[]
      },
      newBotName: '',
      filterBots: '',
      filterPlaybooks: '',
      newBotError: '',
      dialogNow: {
        visible: false,
        delay: 1,
        tasks: 1,
        repeats: 1,
        bot_id: -1,
        project_id:-1,
        playbook_id:'',
        video_ratio: 0
      },
      projectState: false,
      sectionAny: [],
    }
  },
  mounted: function () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'project/DELETED_BOT') {
            //refetch data
        }
        
        if (mutation.type === 'project/BOT_RAN_NOW') {
          this.dialogNow.visible = false;
        }

        if (mutation.type === 'project/SET_STATS_BY_DATE') {
          this.failRate();
        }

        if (mutation.type === 'project/CHANGED_PROJECT_STATE') {
          
        }
    })
  },
  computed: {
    ...mapState('project', {
      news: 'items',
      project: 'projects',
      playbooks: 'playbooks',
      bots: 'bots',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading',
      stats: 'stats',
      advanced: 'advanced',
      accounts: 'accounts',
      proxies: 'proxies',
      proxies_tags: 'proxies_tags',
      languages: 'languages',
      pools: 'pools',
    }),
    ...mapGetters('project', [
    'isEmpty'
    ]),
  },
  created () {
    this.fetchData();
  }
}
</script>
